import React from "react";
import { motion } from "framer-motion";

const dots = [0, 1, 2, 3];

function AppLoading({ message = "Initializing system" }) {
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-background/95 backdrop-blur-sm">
      <div className="relative flex flex-col items-center gap-4">
        <div className="flex items-center gap-3">
          <span className="text-base font-medium tracking-tight text-foreground">
            Core Africa
          </span>
        </div>

        <div className="flex items-center gap-2">
          {dots.map((i) => (
            <motion.span
              // eslint-disable-next-line react/no-array-index-key
              key={i}
              className="h-2 w-2 rounded-full bg-primary"
              initial={{ opacity: 0.3, y: 0 }}
              animate={{ opacity: [0.3, 1, 0.3], y: [0, -4, 0] }}
              transition={{
                duration: 0.9,
                repeat: Infinity,
                delay: i * 0.15,
                ease: "easeInOut",
              }}
            />
          ))}
        </div>

        <p className="text-xs text-muted-foreground font-mono tracking-widest uppercase">
          {message}
        </p>
      </div>
    </div>
  );
}

export default AppLoading;

